var $ce15bd300bae5b84$exports = {};
"use strict";
// Create WebSocket connection.
var $ce15bd300bae5b84$var$socket = new WebSocket("ws://localhost:8765");
// Connection opened
$ce15bd300bae5b84$var$socket.addEventListener("open", function(event) {
    $ce15bd300bae5b84$var$socket.send("Hello Server!");
});
// Listen for messages
$ce15bd300bae5b84$var$socket.addEventListener("message", function(event) {
    console.log("Message from server ", event.data);
});


//# sourceMappingURL=index.bb5f335e.js.map
